import { envSettings } from "core/EnvSettings";
import React from "react";
import { Resource } from "react-admin";
import { Route } from "react-router-dom";
import { developersResource } from "resources/developers";
import { loginLogsResource } from "resources/login-logs";
import { oAuth2RequestsResource } from "resources/oauth2-requests";
import { scannerLogsResource } from "resources/scanner-logs";
import { storageTransactionsResource } from "resources/storage-transactions";
import { sharedThirdPartyAppsResource } from "resources/third-party-apps";

import AdminOrdersExportSearch from "../../pages/admin-order-export-search";
import { adminActionsResource } from "../../resources/admin-actions";
import { adminLogsResource } from "../../resources/admin-log";
import { backupLogPricelistResource } from "../../resources/backup-log-pricelist";
import { commoditiesResource } from "../../resources/commodities";
import { currencyRatesResource } from "../../resources/currencies-and-rates";
import { customerArticlesResource } from "../../resources/customer-articles";
import { customerCompaniesResource } from "../../resources/customer-companies/";
import { customerUsers } from "../../resources/customer-users";
import { deviationsResource } from "../../resources/deviations";
import { deviationsRoutes } from "../../resources/deviations/deviations_routes";
import { customerDriversResource } from "../../resources/drivers";
import { entitiesResource } from "../../resources/entities/";
import { entityDocumentStatusResource } from "../../resources/entity-document-status";
import { eventsResource } from "../../resources/events";
import { externalTerminalLinkResource } from "../../resources/external-terminal-links";
import { financialStatementsResource } from "../../resources/financial-statements";
import { hotlinksResource } from "../../resources/hotlinks";
import { inventoryListResource } from "../../resources/inventory-list";
import { adminInvoicesResource } from "../../resources/invoices";
import { laborForecastResource } from "../../resources/labor-forecast";
// import { mappersResource } from "../../resources/mappers";
import Messages from "../../resources/messages/List/List";
import { notifLogsResource } from "../../resources/notif-logs";
import { orderGroupsResource } from "../../resources/order-groups";
import { orderImportTracksResource } from "../../resources/order-import-tracks/";
import { ordersByAPIResource } from "../../resources/orders-by-api";
import { ordersDraftResource, ordersResource } from "../../resources/orders/";
import { OrdersMultipleChangesPage } from "../../resources/orders/MultipleChanges2";
import { osfcManagersResource } from "../../resources/osfc-users";
import { outdoorDisplayTaskDisplayActionResource } from "../../resources/outdoor-display";
import { ownerCompanyDataResource } from "../../resources/owner-company-data";
import { areasResource, portsResource } from "../../resources/ports-areas";
import { articleTemplatesResource } from "../../resources/pricelist-article-templates";
import { pricelistArticlesResource } from "../../resources/pricelist-articles/";
import { pricelistHolidaysResource } from "../../resources/pricelist-holidays/";
import { recurringTaskResource } from "../../resources/recurring_tasks";
import { tasksResource } from "../../resources/tasks/";
import { terminalsResource } from "../../resources/terminal";
import { terminalSettingPerDateResource } from "../../resources/terminal-setting-per-date";
// import { transportersResource } from '../../resources/transporters';
import { transportTrailersResource } from "../../resources/trailers";
import { translationsResource } from "../../resources/translations";
import { transportTrucksResource } from "../../resources/trucks";
import { trucksTrafficResource } from "../../resources/trucks-traffic";
import { userManualResource } from "../../resources/user-manual";
import { vehicleANPRCamerasResource } from "../../resources/vehicle-anpr-cameras";
import { authenticatedResources } from "./authenticated";

export const adminResources = [
	<Resource name="orders" {...ordersResource} />,
	<Resource name="draft-orders" {...ordersDraftResource} />,
	<Resource name="orders-by-api" {...ordersByAPIResource} />,
	<Resource name="deviations" {...deviationsResource} />,
	<Resource name="order-groups" {...orderGroupsResource} />,
	<Resource name="order-import-tracks" {...orderImportTracksResource} />,
	<Resource name="oauth2-requests" {...oAuth2RequestsResource} />,
	envSettings.REACT_APP_FF_STORAGE_MODULE && (
		<Resource {...storageTransactionsResource} name="storage-transactions" />
	),
	<Resource name="pallets-and-boxes" intent="registration" />,
	<Resource {...osfcManagersResource} name="company-users" />,
	<Resource {...developersResource} name="developers" />,
	<Resource {...customerCompaniesResource} name="customer-companies" />,
	<Resource {...customerUsers} name="customer-users" />,
	// <Resource {...mappersResource} name="mappers" />,
	// <Resource {...transportersResource} name="transporters" />,
	<Resource name="transporters" intent="registration" />,
	<Resource {...customerDriversResource} create={null} edit={null} name="drivers" />,
	<Resource {...transportTrucksResource} name="trucks" />,
	<Resource {...transportTrailersResource} name="trailers" />,
	<Resource {...terminalsResource} name="terminal" />,
	<Resource {...externalTerminalLinkResource} name="external-terminal-links" />,
	<Resource
		{...pricelistArticlesResource}
		name="pricelist-articles"
		options={{ hasUpload: true }}
	/>,
	<Resource {...commoditiesResource} name="commodities" />,
	<Resource {...pricelistHolidaysResource} name="pricelist-holidays" />,
	<Resource {...portsResource} name="ports" intent="registration" />,
	<Resource {...areasResource} name="areas" intent="registration" />,
	<Resource name="storage-places-lookup" intent="registration" />,

	<Resource
		{...articleTemplatesResource}
		name="pricelist-article-templates"
		intent="registration"
	/>,
	<Resource name="notif-logs" {...notifLogsResource} />,
	<Resource name="trucks-traffic" {...trucksTrafficResource} />,
	<Resource name="vehicle-anpr-cameras" {...vehicleANPRCamerasResource} />,
	<Resource name="labor-forecast" {...laborForecastResource} />,
	<Resource name="recurring-tasks" {...recurringTaskResource} />,
	<Resource {...translationsResource} name="translations" />,
	<Resource {...hotlinksResource} name="hotlinks" />,
	<Resource {...ownerCompanyDataResource} name="owner-company-data" />,
	<Resource {...adminLogsResource} name="admin-logs" />,
	<Resource {...loginLogsResource} name="login-logs" />,
	<Resource {...scannerLogsResource} name="scanner-logs" />,

	<Resource {...adminActionsResource} name="admin-actions" />,
	<Resource {...customerArticlesResource} name="customer-articles" />,
	<Resource {...adminInvoicesResource} name="invoices" />,
	<Resource name="task-display-actions" {...outdoorDisplayTaskDisplayActionResource} />,

	<Resource {...backupLogPricelistResource} name="backup-log-pricelist" />,
	<Resource {...eventsResource} name="events" />,

	<Resource name="tasks" {...tasksResource} />,
	<Resource name="entities" {...entitiesResource} />,
	<Resource name="financial-statements" {...financialStatementsResource} />,
	<Resource {...currencyRatesResource} name="currency-rates" intent="registration" />,

	<Resource name="user-manuals" {...userManualResource} />,
	<Resource name="order-history" intent="registration" />,
	<Resource name="pallet-history" intent="registration" />,
	<Resource name="task-history" intent="registration" />,
	<Resource name="entity-history" intent="registration" />,
	<Resource name="task-statuses" intent="registration" />,
	<Resource name="deviation-statuses" intent="registration" />,

	<Resource name="backup-pricelist-articles-with-special" intent="registration" />,
	<Resource name="pricelist-special-price" intent="registration" />,
	<Resource name="pricelist-articles-autocomplete" intent="registration" />,
	<Resource name="customer-employees" intent="registration" />,

	<Resource name="users" intent="registration" />,
	<Resource name="storage-places" intent="registration" />,
	<Resource name="companies" intent="registration" />,
	<Resource name="order-statuses" intent="registration" />,
	<Resource name="outgoing-doc-statuses" intent="registration" />,
	<Resource name="company-notifications" intent="registration" />,
	// <Resource name="customer-company-mappers" intent="registration" />,
	<Resource name="time-zones" intent="registration" />,
	<Resource name="cooler-types" intent="registration" />,
	<Resource name="order-pricelist-history" intent="registration" />,
	<Resource
		name="order-pricelist"
		intent="registration"
		options={{ hasAdd: true, hasEdit: true }}
	/>,
	<Resource name="rank-priorities" intent="registration" />,
	<Resource name="entity-document-status" {...entityDocumentStatusResource} />,
	<Resource name="third-party-apps" {...sharedThirdPartyAppsResource} />,
	<Resource name="deviations-history" intent="registration" />,
	<Resource name="document-templates" intent="registration" />,
	<Resource name="mappers" intent="registration" />,
	<Resource name="custom-fields" intent="registration" />,
	<Resource name="product-articles" intent="registration" />,
	<Resource name="order-product-articles" intent="registration" />,
	<Resource name="product-numbers" intent="registration" />,
	<Resource name="product-names" intent="registration" />,
	<Resource name="automatic-pallets-reservation" intent="registration" />,
	<Resource name="oauth2-available-scopes" intent="registration" />,
	<Resource name="storage-terminals" intent="registration" />,
	<Resource name="pallets" intent="registration" />,
	<Resource name="storage-inventorization-statuses" intent="registration" />,
	<Resource name="inventory-list" {...inventoryListResource} />,
	<Resource name="terminal-setting-per-date" {...terminalSettingPerDateResource} />,
	...authenticatedResources,
];

export const adminRoutes = [
	...Object.values(deviationsRoutes),
	// ...entitiesRouts,
	<Route exact path="/messages" component={Messages} />,
	<Route exact path="/admin-orders-export-search" component={AdminOrdersExportSearch} />,
	<Route exact path="/orders/multiple-changes" component={OrdersMultipleChangesPage} />,
	<Route exact path="/draft-orders/multiple-changes" component={OrdersMultipleChangesPage} />,
];
